export default "__VITE_ASSET__DRJwEy9o__"